import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=629f98cd&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"
import style0 from "./Files.vue?vue&type=style&index=0&id=629f98cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f98cd",
  null
  
)

export default component.exports